import { Container } from './primitives/Misc.js';
import { useAnim3d } from '../hooks/useAnim3d.js';
import './Safety.css';

const CHECKLIST = [
  'Read-only access at connect; write scopes requested later, per action type',
  'Auto-merge stays locked until sampled precision reaches 98% in your workspace',
  'A rejected pair is never proposed again on the same evidence',
  /* ⚠️ Corrected 2026-07-30. This read "UK, EU or US data residency" — and **UK is not
     a residency option**. The `/v1/` contract's `Region` enum is `[eu, us]`, and
     `packages/config` says of `uk`: "not a value here and must never become one". The
     UK is where the *control plane* lives (ADR-057) — our own records about clients,
     holding no client record content — which is the exact conflation planes.md §1 and
     `lint:vocab` exist to prevent, here on the public site of a data-residency product
     claiming a jurisdiction we do not offer.
     Also updated for ADR-068: a client may hold several regions, so "chosen at
     workspace creation" was only ever true of the first one. */
  'EU or US data residency per system, so records stay where they came from',
];

function SnapshotStack() {
  return (
    <div className="land-safety__stack-frame">
      <div className="land-safety__stack">
        <div className="land-safety__layer land-safety__layer--0" />
        <div className="land-safety__layer land-safety__layer--1" />
        <div className="land-safety__layer land-safety__layer--2" />
        <div className="land-safety__layer land-safety__layer--top" data-anim3d="1" />
      </div>
      <div className="land-safety__stack-caption">snapshot layers · run_4821 · 27 days left</div>
    </div>
  );
}

export function Safety() {
  useAnim3d();

  return (
    <Container id="decide" className="land-section">
      <div className="land-safety__grid">
        <SnapshotStack />
        <div>
          <h2 className="land-safety__title">
            Every write sits on top of a snapshot you can lift off again.
          </h2>
          <p className="land-safety__lede">
            We archive rather than delete, keep the surviving record's ID stable, and write a
            receipt for every object touched. If a merge was wrong, roll the whole run back — not
            record by record.
          </p>
          <ul className="land-checklist">
            {CHECKLIST.map((item) => (
              <li key={item}>
                <span className="land-checklist__mark">✓</span>
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Container>
  );
}
